import React from 'react';
import {ApplicationWorkflowSwitch} from "./ApplicationWorkflowSwitch";
import {ApplicationDataSource} from 'portal-core/components/data/ApplicationDataSource';
import {NavigationConsumer} from "portal-core/navigation/NavigationConusmer";

export function ApplicationPage() {

  return <NavigationConsumer>
    {
      ([applicationId]) => <ApplicationDataSource applicationId={applicationId}>
        <ApplicationWorkflowSwitch/>
      </ApplicationDataSource>
    }
  </NavigationConsumer>;
}
